<template>
  <div class="mc-map-wrapper">
    <div v-if="!isStreetViewMode" class="mc-map-search">
      <div class="mc-map-search__wrapper">
        <i class="mc-fa icon-fill_search"></i>
        <b-form-input
          v-model="textSearch"
          autocomplete="off"
          type="search"
          placeholder="Cari Kendaraan"
          class="mc-map-search__input"
          @input="searchAll"
          @keydown.enter.prevent="searchFleet($event)"
          @focus="responsiveClose"
        />
      </div>
      <div v-if="suggestSearch" class="mc-map-search__suggest">
        <div v-if="items.licensePlate.length" class="mc-map-search__suggest-item">
          <p>
            <i class="mc-fa icon-outline_truck-bak"></i>
            {{ $t('global.object.licensePlate') }}
          </p>
          <div class="mc-map-search__suggest-item-list">
            <span v-for="(row, index) in items.licensePlate" :key="index">
              <a @click="searchFleet(row.licensePlate, row.vehicleId)">
                {{ row.licensePlate }}
              </a>
            </span>
          </div>
        </div>

        <div v-if="items.driver.length" class="mc-map-search__suggest-item">
          <p>
            <i class="mc-fa icon-outline_truck-bak"></i>
            {{ $t('global.object.driver') }}
          </p>
          <div class="mc-map-search__suggest-item-list">
            <span v-for="(row, index) in items.driver" :key="index">
              <a @click="searchFleet(row.vehicle.driver1.fullname, row.vehicleId)">{{
                row.vehicle.driver1.fullname
              }}</a>
            </span>
          </div>
        </div>

        <div
          v-if="!items.driver.length && !items.licensePlate.length"
          class="mc-map-search__suggest-item"
        >
          <div class="text-center">{{ $t('global.text.noData') }}</div>
        </div>
      </div>
    </div>

    <div v-if="!isStreetViewMode && !isNotificationLocationFlagEnabled" class="mc-map-action-btn">
      <div role="button" class="__create-notification-wa-btn" @click="openNotificationWaModal">
        <v-lottie-player
          :animationData="require('@/assets/images/message/bell-icon.json')"
          autoplay
          loop
          width="24px"
          height="24px"
        />
        <span>Buat Pengingat</span>
      </div>
    </div>

    <GmapMap
      id="map"
      ref="FleetMap"
      :center="$store.state.map.center"
      :zoom="parseFloat($store.state.map.zoom)"
      :options="gMapOptions"
      :map-type-id="$store.state.fleets.mapMode"
      class="mc-map"
    >
      <span v-if="$store.state.map.infoWindow.type === 'fleet'" id="fleet-map" ref="fleet-map">
        <GmapCluster
          v-if="$store.state.fleets.fleetCluster === true"
          :averageCenter="true"
          :zoom-on-click="true"
        >
          <gmap-custom-marker
            v-for="(gmp, index) in fleetsList"
            :key="index"
            :marker="{
              lat: parseFloat(gmp.latitude),
              lng: parseFloat(gmp.longitude),
            }"
            :offsetY="25"
          >
            <div class="text-center">
              <div
                v-if="$store.state.fleets.markerPlate === true"
                class="rounded"
                :class="`${
                  $store.state.fleets.markerLabelLayout === true
                    ? 'bg-white bottom-icon-shape'
                    : 'bg-transparant'
                }`"
                @click="Centering(gmp, true)"
              >
                <h6 class="p-1">
                  <strong>{{ gmp.licensePlate }}</strong>
                </h6>
              </div>

              <span
                v-if="gmp.calculatedMotionStatus === 'P'"
                :class="
                  gmp.licensePlate == $store.state.map.infoWindow.detail.licensePlate
                    ? 'mc-car-ico active'
                    : 'mc-car-ico'
                "
              >
                <img
                  :src="
                    require(`@/assets/images/vehicles/${gmp.vehicle.vehicleType.icon}/${gmp.vehicle.vehicleType.icon}-red.png`)
                  "
                  :style="`transform: rotate(${parseInt(gmp.direction)}deg);`"
                  :alt="`mceasy-liveview-${gmp.vehicle.vehicleType.icon}-icon`"
                  @click="Centering(gmp, true)"
                />
              </span>

              <span
                v-else-if="gmp.calculatedMotionStatus === 'M'"
                :class="
                  gmp.licensePlate == $store.state.map.infoWindow.detail.licensePlate
                    ? 'mc-car-ico active'
                    : 'mc-car-ico'
                "
              >
                <img
                  :src="
                    require(`@/assets/images/vehicles/${gmp.vehicle.vehicleType.icon}/${gmp.vehicle.vehicleType.icon}-green.png`)
                  "
                  :style="`transform: rotate(${parseInt(gmp.direction)}deg);`"
                  :alt="`mceasy-liveview-${gmp.vehicle.vehicleType.icon}-icon`"
                  @click="Centering(gmp, true)"
                />
              </span>

              <span
                v-else-if="gmp.calculatedMotionStatus === 'I'"
                :class="
                  gmp.licensePlate == $store.state.map.infoWindow.detail.licensePlate
                    ? 'mc-car-ico active'
                    : 'mc-car-ico'
                "
              >
                <img
                  :src="
                    require(`@/assets/images/vehicles/${gmp.vehicle.vehicleType.icon}/${gmp.vehicle.vehicleType.icon}-orange.png`)
                  "
                  :style="`transform: rotate(${parseInt(gmp.direction)}deg);`"
                  :alt="`mceasy-liveview-${gmp.vehicle.vehicleType.icon}-icon`"
                  @click="Centering(gmp, true)"
                />
              </span>

              <span
                v-else-if="gmp.calculatedMotionStatus === 'O' || gmp.calculatedMotionStatus === 'U'"
                :class="
                  gmp.licensePlate == $store.state.map.infoWindow.detail.licensePlate
                    ? 'mc-car-ico active'
                    : 'mc-car-ico'
                "
              >
                <img
                  :src="
                    require(`@/assets/images/vehicles/${gmp.vehicle.vehicleType.icon}/${gmp.vehicle.vehicleType.icon}-grey.png`)
                  "
                  :style="`transform: rotate(${parseInt(gmp.direction)}deg);`"
                  :alt="`mceasy-liveview-${gmp.vehicle.vehicleType.icon}-icon`"
                  @click="Centering(gmp, true)"
                />
              </span>
            </div>
          </gmap-custom-marker>
        </GmapCluster>
        <gmap-custom-marker
          v-for="(gmp, index) in fleetsList"
          v-else
          :key="index"
          :marker="{
            lat: parseFloat(gmp.latitude),
            lng: parseFloat(gmp.longitude),
          }"
          :offsetY="25"
        >
          <div class="text-center">
            <div
              v-if="$store.state.fleets.markerPlate === true"
              class="rounded"
              :class="`${
                $store.state.fleets.markerLabelLayout === true
                  ? 'bg-white bottom-icon-shape'
                  : 'bg-transparant'
              }`"
              @click="Centering(gmp, true)"
            >
              <h6 class="p-1">
                <strong>{{ gmp.licensePlate }}</strong>
              </h6>
            </div>

            <img
              v-if="gmp.calculatedMotionStatus === 'P'"
              :src="
                require(`@/assets/images/vehicles/${gmp.vehicle.vehicleType.icon}/${gmp.vehicle.vehicleType.icon}-red.png`)
              "
              :style="`transform: rotate(${parseInt(gmp.direction)}deg);`"
              :alt="`mceasy-liveview-${gmp.vehicle.vehicleType.icon}-icon`"
              @click="Centering(gmp, true)"
            />

            <img
              v-else-if="gmp.calculatedMotionStatus === 'M'"
              :src="
                require(`@/assets/images/vehicles/${gmp.vehicle.vehicleType.icon}/${gmp.vehicle.vehicleType.icon}-green.png`)
              "
              :style="`transform: rotate(${parseInt(gmp.direction)}deg);`"
              :alt="`mceasy-liveview-${gmp.vehicle.vehicleType.icon}-icon`"
              @click="Centering(gmp, true)"
            />

            <img
              v-else-if="gmp.calculatedMotionStatus === 'I'"
              :src="
                require(`@/assets/images/vehicles/${gmp.vehicle.vehicleType.icon}/${gmp.vehicle.vehicleType.icon}-orange.png`)
              "
              :style="`transform: rotate(${parseInt(gmp.direction)}deg);`"
              :alt="`mceasy-liveview-${gmp.vehicle.vehicleType.icon}-icon`"
              @click="Centering(gmp, true)"
            />

            <img
              v-else-if="gmp.calculatedMotionStatus === 'O' || gmp.calculatedMotionStatus === 'U'"
              :src="
                require(`@/assets/images/vehicles/${gmp.vehicle.vehicleType.icon}/${gmp.vehicle.vehicleType.icon}-grey.png`)
              "
              :style="`transform: rotate(${parseInt(gmp.direction)}deg);`"
              :alt="`mceasy-liveview-${gmp.vehicle.vehicleType.icon}-icon`"
              @click="Centering(gmp, true)"
            />
          </div>
        </gmap-custom-marker>
      </span>
    </GmapMap>

    <ModalInfo :temporary-live-view="temporaryLiveView" />
  </div>
</template>
<script>
import { MixPanel } from '@/mixin/mixpanel'

import GmapCustomMarker from 'vue2-gmap-custom-marker'
import { gmapApi } from 'vue2-google-maps'
import VueLottiePlayer from 'vue-lottie-player'

import { Helper } from '@/mixin/helper'
import responsive from '@/mixin/responsive'
import { mapGetters } from 'vuex'

import ModalInfo from '../Modal/ModalInfo'

export default {
  name: 'GmapFleet',
  components: {
    'gmap-custom-marker': GmapCustomMarker,
    ModalInfo,
    vLottiePlayer: VueLottiePlayer,
  },
  mixins: [Helper, MixPanel, responsive],
  props: {
    temporaryLiveView: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      gMapOptions: {},
      isStreetViewMode: false,

      phaseOneShow: false,
      textSearch: '',
      suggestSearch: false,
      items: {
        licensePlate: [],
        driver: [],
      },

      map: null,
      trafficLayer: null,
      locations: [],
      currentPlace: null,
      markers: [],
      places: [],
      address: '',
      geo: {
        circle: [],
        polygon: [],
      },

      geofences: {
        geofences: [],
      },

      form: {
        speed_limit: null,
        np_hp: null,
      },

      isCenteringMap: false,
      popOverConfiguration: false,
      popOverShare: false,
      modalStatus: {
        configuration: {
          status: false,
          title: '',
          type: '',
        },
      },
    }
  },

  computed: {
    google: gmapApi,
    showSideBar() {
      return this.$store.getters['sidebar/g_sideBarOpen']
    },
    ...mapGetters('fleets', ['fleetsList']),
    ...mapGetters({
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
    isNotificationLocationFlagEnabled() {
      return this.getFeatureFlagData('notification.temporary_track').value
    },
  },

  watch: {
    fleetsList(newValue) {
      if (newValue.length === 1) {
        this.$store.dispatch('map/setZOOM', {
          isZoom: true,
          zoom: 15,
          lat: Number(newValue[0].latitude),
          lng: Number(newValue[0].longitude),
        })

        return
      }

      if (this.isCenteringMap) return

      this.fitBounds(newValue)
      this.isCenteringMap = true
    },
  },

  async mounted() {
    const self = this
    await this.$refs.FleetMap.$mapPromise.then((map) => {
      self.map = map
      self.gMapOptions = {
        minZoom: 3,
        mapTypeControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: self.google.maps.ControlPosition.LEFT_BOTTOM,
        },
        scaleControl: true,
        streetViewControl: true,
        streetViewControlOptions: {
          position: self.google.maps.ControlPosition.LEFT_BOTTOM,
        },
        fullscreenControl: false,
      }

      const streetView = map.getStreetView()
      streetView.addListener('visible_changed', () => {
        self.isStreetViewMode = streetView.getVisible()
      })

      const trafficLayer = new this.google.maps.TrafficLayer()
      this.trafficLayer = trafficLayer

      this.track('Map Loaded on Public View Temporary Track')
    })

    await self.setting()
    this.$root.$on('SettingSelectOptions', function () {
      self.setting()
    })
  },

  methods: {
    searchAll(text) {
      if (text) {
        this.suggestSearch = true
      } else {
        if (this.items.driver.length || this.items.licensePlate.length) {
          this.$root.$emit('searchFleet', null)
        }

        this.suggestSearch = false
        clearTimeout(this.timer)
        return
      }
      clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        var filter = []

        filter = this.fleetsList.filter((fleet) =>
          fleet.vehicle.driver1
            ? fleet.vehicle.driver1.fullname.toLowerCase().match(text.toLowerCase())
            : null
        )
        this.items.driver = [...filter]

        filter = this.fleetsList.filter((fleet) =>
          fleet.licensePlate.toLowerCase().match(text.toLowerCase())
        )

        this.items.licensePlate = [...filter]
      }, 1000)
    },

    searchFleet(text, vehicleId) {
      if (typeof text === 'string') {
        this.textSearch = text
        const gmp = this.fleetsList.filter((fleet) => fleet.vehicleId === vehicleId)
        this.Centering(gmp[0], true)
        this.$root.$emit('searchFleet', text)
      } else {
        if (this.mediaQuery.matches && !this.$store.state.sidebar.sideBarOpen) {
          this.$store.commit('sidebar/toggleSideBar')
          this.$bvModal.hide('select_options_temp')
          this.$bvModal.hide('modal-info-temp')
        }
        this.$root.$emit('searchFleet', this.textSearch)
      }

      this.$nextTick(() => {
        this.suggestSearch = false
      })
    },

    responsiveClose() {
      if (this.mediaQuery.matches) {
        this.$bvModal.hide('select_options_temp')
        this.$bvModal.hide('modal-info-temp')
      }
    },

    openNotificationWaModal() {
      this.track('Pelacakan Sementara Create Reminder Clicked')

      this.$bvModal.show('notification-wa-modal')
    },

    openInGMap() {
      window.open(
        'http://maps.google.com/maps?&z=15&mrt=yp&t=m&q=' +
          this.$store.state.map.infoWindow.position.lat +
          '+' +
          this.$store.state.map.infoWindow.position.lng,
        '_blank'
      )
    },

    async zoom(Cluster) {
      await this.$store.dispatch('map/setZOOM', {
        zoom: this.map.getZoom() + 1,
        lat: Cluster.center_.lat,
        lng: Cluster.center_.lng,
      })
    },

    setting() {
      const cookiesMap = new Map()
      document.cookie.split('; ').forEach((cookie) => {
        const [key, value] = cookie.split('=')
        cookiesMap.set(key, value)
      })

      // set traffic
      if (cookiesMap.get('traffic') === 'true') {
        this.trafficLayer.setMap(this.map)
      } else {
        this.trafficLayer.setMap(null)
      }

      var visible = 'off'
      // set location_google visibilities
      if (cookiesMap.get('location_google') === 'true') {
        visible = 'on'
      }

      this.map.setOptions({
        styles: [
          {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [
              {
                visibility: visible,
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: visible,
              },
            ],
          },
          {
            featureType: 'poi',
            stylers: [{ visibility: visible }],
          },
          {
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers: [{ visibility: visible }],
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#d5e6f9',
              },
            ],
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#d5e6f9',
              },
            ],
          },
          {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: [
              {
                weight: '1',
              },
              {
                color: '#d5e6f9',
              },
              {
                saturation: '0',
              },
            ],
          },
        ],
      })
    },

    async Centering(gmp, open, zoom) {
      if (!zoom) {
        zoom = 15
      }

      this.$store.dispatch('map/closeInfo', false)

      const data = {
        zoom: zoom,
        open: open,
        gmp: gmp,
        type: 'fleet',
      }

      await this.$store.dispatch('map/setCENTER', data)
      this.$bvModal.show('modal-info-temp')

      if (open) {
        await this.$store.dispatch('map/requestAddress', {
          lat: gmp['latitude'],
          lng: gmp['longitude'],
        })
      }
    },

    async fitBounds(locations) {
      await this.$nextTick()

      let bounds = new this.google.maps.LatLngBounds()
      locations.forEach((location) => {
        bounds.extend(new this.google.maps.LatLng(location.latitude, location.longitude))

        this.map.fitBounds(bounds)
      })
    },

    CloseInfo() {
      this.$store.dispatch('map/closeInfo', false)
    },

    setModal(row) {
      this.$store.dispatch('fleets/setHistory', {
        hullNo: row.vehicle.hullNo,
        type: row.vehicle.vehicleType.type,
        category: row.vehicle.vehicleType.category,
        licensePlate: row.licensePlate,
        imei: row.vehicle.imei,
        vehicleId: row.vehicleId,
        driver: row.driver,
        direction: row.direction,
        calculatedMotionStatus: row.calculatedMotionStatus,
        tripDrivetime: row.tripDrivetime,
        tripDistance: row.tripDistance,
        tripstartOn: row.tripstartOn,
        lastPacket: row.lastPacket,
        latitude: row.latitude,
        longitude: row.longitude,
        icon: row.vehicle.vehicleType.icon,
        lastPositionStatus: row.lastPositionStatus,
      })
      this.$store.dispatch('map/modalFleetHistory', true)
    },

    showModalConfiguration(title, type) {
      this.modalStatus.configuration.status = true
      this.modalStatus.configuration.title = title
      this.modalStatus.configuration.type = type

      setTimeout(() => {
        this.popOverConfiguration = !this.popOverConfiguration
      }, 10)
    },

    closeModalConfiguration() {
      this.modalStatus.configuration.status = false
      this.modalStatus.configuration.title = ''
      this.modalStatus.configuration.type = ''
    },
  },
}
</script>
<style lang="scss" scoped>
:deep(.gm-ui-hover-effect) > span {
  background-color: #000;
}
</style>
<style lang="scss">
.mc-map-action-btn {
  .__create-notification-wa-btn {
    display: flex;
    color: $yellow-500;
    background-color: $yellow-100;
    border: 1px solid $yellow-500;
    gap: 5px;
    border-radius: 24px;
    padding: 5px 12px;
    align-items: center;
    transition: 0.3s;

    span {
      font-size: 12px;
      font-weight: 600;
    }
  }

  .__create-notification-wa-btn:hover {
    background-color: $yellow-500;
    color: $yellow-100;

    svg {
      filter: brightness(10);
    }
  }
}
</style>
